<template>
  <transition name="slide">
    <div v-show="isShown" class="mobile-menu-wrapper">
      <!-- Close button -->
      <div @click="toggleMenu()" class="close-toggle">
        <img src="../../../assets/img/icons/ic_close.svg" class="close-icon" alt="close icon"/>
      </div>

      <!-- Menu items -->
      <div class="menu-items">
        <router-link @click.native="onItemClick()"
                     :to="{name: HOMEPAGE}"
                     exact-active-class="active"
                     class="item link-yellow link">
          home<span class="dot">.</span>
        </router-link>
        <router-link @click.native="onItemClick()"
                     :to="{name: PROJECTS}"
                     exact-active-class="active"
                     class="item link-purple link">
          projects<span class="dot">.</span>
        </router-link>
        <router-link @click.native="onItemClick"
                     :to="{name: ABOUT_ME}"
                     exact-active-class="active"
                     class="item link-red">
          about me<span class="dot">.</span>
        </router-link>
        <router-link @click.native="onItemClick"
                     :to="{name: CONTACT_ME}"
                     exact-active-class="active"
                     class="item link-blue-light">
          contact me<span class="dot">.</span>
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import {ABOUT_ME, HOMEPAGE, PROJECTS, CONTACT_ME} from "@/router/modules/home";

export default {
  name: "MenuMobile",
  components: {},
  props: {},
  emits: ['close'],
  data: () => ({
    ABOUT_ME,
    HOMEPAGE,
    PROJECTS,
    CONTACT_ME,
    isShown: false,
  }),
  methods: {
    toggleMenu: function () {
      this.isShown = !this.isShown;
      this.setBodyOverflow();
    },

    onItemClick: function () {
      // After redirecting to a new page, the menu should be closed.
      this.toggleMenu();
    },

    // Body helper
    setBodyOverflow: function () {
      this.isShown ? document.body.classList.add('no-overflow') : document.body.classList.remove('no-overflow');
    }
  },
  mounted() {
    this.setBodyOverflow();

    window.addEventListener('resize', (event) => {
      if (event.target.innerWidth > 576 && this.isShown) {
        this.toggleMenu();
      }
    })
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.links";
@import "~@/assets/css/base.vue-transitions.scss";

.mobile-menu-wrapper {
  @include position-elevation(fixed, $top: 0, $right: 0, $bottom: 0, $left: 0, $elevation: 260);
  align-items: center;
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  text-transform: uppercase;

  .menu-item {
    &:not(:last-child) {
      margin-bottom: 25px;
    }
  }
}

// Close button
.close-toggle {
  @include position-elevation(absolute, $top: 15px, $right: 15px, $elevation: 260);

  .close-icon {
    width: 35px;
  }
}

// Links
.menu-items {
  align-items: center;
  display: flex;
  flex-direction: column;

  .item {
    @extend .font-roboto;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    opacity: 0.5;

    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }

  .active {
    opacity: 1;
  }
}

@media screen and (min-width: $screen-sm) {
  .mobile-menu-wrapper {
    display: none;
  }
}

@media screen and (min-width: $screen-md) {
}
</style>
